import {
  ActivityPageSchema,
  AdminActivityListSchema,
  AdminActivityPageQuerySchema,
  AdminActivityPageSchema,
  AdminConnectionsResponseSchema,
  AdminSearchQuerySchema,
  AdminSearchResponseSchema,
  AdminMeSchema,
  AiAgentChannelAssignmentListSchema,
  AiAgentChannelAssignmentSchema,
  AiAgentListSchema,
  AiAgentSchema,
  AiSkillListSchema,
  AiSkillSchema,
  AppointmentPageSchema,
  AppointmentSchema,
  DealershipBillingSummarySchema,
  OpsSnapshotSchema,
  type OpsSnapshot,
  PlatformBillingSummarySchema,
  type DealershipBillingSummary,
  type PlatformBillingSummary,
  CreateAiAgentChannelAssignmentSchema,
  CreateAiAgentBodySchema,
  UpdateAiAgentSchema,
  CreateAiSkillSchema,
  A2pBusinessProfileSchema,
  A2pStatusSchema,
  A2pSubmitBrandSchema,
  A2pSubmitCampaignSchema,
  CreateTelephonyAccountSchema,
  TelephonyUsageSummarySchema,
  TelephonyAccountListSchema,
  TelephonyAvailableNumberListSchema,
  TelephonyPhoneNumberListSchema,
  TelephonyPhoneNumberSchema,
  TelephonyPurchaseNumberSchema,
  TelephonySearchNumbersSchema,
  TelephonyUpdateNumberSchema,
  TelephonyAccountSchema,
  TelephonyAccountSearchResultListSchema,
  UpdateTelephonyAccountSchema,
  type AiAgent,
  type AiAgentChannelAssignment,
  type AiSkill,
  type CreateAiAgentChannelAssignmentDto,
  type CreateAiAgentDto,
  type UpdateAiAgentDto,
  type CreateAiSkillDto,
  type CreateInventoryImport,
  type InventoryImport,
  type InventoryImportRun,
  type UpdateInventoryImport,
  InventoryImportListSchema,
  InventoryImportRunListSchema,
  InventoryImportSchema,
  type A2pBusinessProfileDto,
  type A2pStatus,
  type A2pSubmitBrandDto,
  type A2pSubmitCampaignDto,
  type CreateTelephonyAccountDto,
  type TelephonyUsageSummary,
  type TelephonyAccount,
  type TelephonyAccountSearchResult,
  type TelephonyAvailableNumber,
  type TelephonyPhoneNumber,
  type TelephonyPurchaseNumberDto,
  type TelephonySearchNumbersDto,
  type TelephonyUpdateNumberDto,
  type UpdateTelephonyAccountDto,
  ChannelOnboardingInfoSchema,
  ChannelPageSchema,
  ChannelSchema,
  ContactChannelPageSchema,
  ContactChannelSchema,
  ContactPageSchema,
  ContactSchema,
  LeadPageSchema,
  LeadSchema,
  AssignTaskSchema,
  CreateAppointmentSchema,
  CreateChannelSchema,
  CreateContactChannelBodySchema,
  CreateContactSchema,
  CreateLeadSchema,
  CreateInventoryVehicleSchema,
  CreateRooftopSchema,
  CreateTaskSchema,
  CreateUserMembershipSchema,
  AdminCreateUserSchema,
  MoveTaskSchema,
  SnoozeTaskSchema,
  TaskPageSchema,
  TaskSchema,
  UpdateTaskSchema,
  DealershipDetailSchema,
  DealershipDirectoryPageSchema,
  DealershipDirectoryQuerySchema,
  DealershipListSchema,
  DealershipOnboardingSchema,
  DealershipSchema,
  InventorySearchRequestSchema,
  InventorySearchResponseSchema,
  InventoryVehiclePageSchema,
  InventoryVehicleSchema,
  OnboardingCreateSchema,
  RooftopListSchema,
  RooftopSchema,
  ConnectEmailChannelSchema,
  EmailAddressAvailabilitySchema,
  UpdateAppointmentSchema,
  UpdateChannelSchema,
  UpdateContactChannelSchema,
  UpdateContactSchema,
  UpdateLeadSchema,
  UpdateDealershipSchema,
  UpdateInventoryVehicleSchema,
  UpdateRooftopSchema,
  UpdateUserMembershipSchema,
  AdminUpdateUserSchema,
  UserListSchema,
  UserMembershipSchema,
  UserSchema,
  type ActivityPage,
  type AdminContactDirectoryQuery,
  type AdminActivity,
  type AdminActivityPage,
  type AdminActivityPageQuery,
  type AdminConnectionsResponse,
  type AdminSearchQuery,
  type AdminSearchResponse,
  type AdminMe,
  type Appointment,
  type AppointmentPage,
  type AssignTaskDto,
  type Channel,
  type ChannelOnboardingInfo,
  type ChannelPage,
  type Contact,
  type ContactChannel,
  type ContactChannelPage,
  type ContactPage,
  type Lead,
  type LeadPage,
  type CreateAppointmentDto,
  type CreateChannelDto,
  type CreateContactChannelDto,
  type CreateContactDto,
  type CreateLeadDto,
  type CreateInventoryVehicleDto,
  type CreateRooftopDto,
  type CreateTaskDto,
  type AdminCreateUserDto,
  type CreateUserMembershipDto,
  type Dealership,
  type DealershipDetail,
  type DealershipDirectoryPage,
  type DealershipDirectoryQuery,
  type DealershipOnboarding,
  type UpdateOnboardingStepDto,
  type InventorySearchRequest,
  type InventorySearchResponse,
  type InventoryVehicle,
  type InventoryVehiclePage,
  type MoveTaskDto,
  type OnboardingCreateDto,
  type Rooftop,
  type ConnectEmailChannelDto,
  type EmailAddressAvailability,
  type SnoozeTaskDto,
  type Task,
  type TaskPage,
  type UpdateAppointmentDto,
  type UpdateTaskDto,
  type UpdateChannelDto,
  type UpdateContactChannelDto,
  type UpdateContactDto,
  type UpdateLeadDto,
  type UpdateDealershipDto,
  type UpdateInventoryVehicleDto,
  type UpdateRooftopDto,
  type AdminUpdateUserDto,
  type UpdateUserMembershipDto,
  type User,
  type UserMembership,
  ApiKeyCreatedSchema,
  ApiKeySchema,
  CreateIntegrationSchema,
  IntegrationDeliverySchema,
  IntegrationListSchema,
  IntegrationSchema,
  UpdateIntegrationSchema,
  VerifyIntegrationTokenRequestSchema,
  VerifyIntegrationTokenResponseSchema,
  type ApiKey,
  type ApiKeyCreated,
  type CreateIntegration,
  type Integration,
  type IntegrationDelivery,
  type UpdateIntegration,
  type VerifyIntegrationTokenRequest,
  type VerifyIntegrationTokenResponse,
  ConsentEventPageSchema,
  ContactTagListSchema,
  ContactVehiclePageSchema,
  FollowUpPageSchema,
  TradeInPageSchema,
  VehicleInterestPageSchema,
  type ConsentEventPage,
  type ContactTag,
  type ContactVehiclePage,
  type FollowUpPage,
  type TradeInPage,
  type VehicleInterestPage,
  AdminSchema,
  CreateOutreachNoteSchema,
  EmailOutreachProspectSchema,
  type EmailOutreachProspectDto,
  CreateOutreachProspectSchema,
  ImportOutreachProspectsSchema,
  ImportOutreachResultSchema,
  OutreachNoteSchema,
  OutreachProspectPageSchema,
  OutreachProspectSchema,
  OutreachSummarySchema,
  UpdateOutreachProspectSchema,
  type Admin,
  type CreateOutreachNoteDto,
  type CreateOutreachProspectDto,
  type ImportOutreachResult,
  type OutreachListQuery,
  type OutreachNote,
  type OutreachProspect,
  type OutreachProspectPage,
  type OutreachSummary,
  type UpdateOutreachProspectDto,
} from "@lumika/shared";
import { z } from "zod";
import { apiFetch } from "./client";

// Lightweight zod shapes for the model catalog responses. Kept here
// (not in @lumika/shared) because the model catalog is admin-only.
const ProviderSchema = z.object({
  key: z.string(),
  displayName: z.string(),
  description: z.string(),
  defaultModelId: z.string(),
  hasApiKey: z.boolean(),
});
const ModelSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  description: z.string(),
  profile: z.enum(["balanced", "quality", "fast", "economy"]),
  latency: z.enum(["fast", "balanced", "deliberate"]),
  cost: z.enum(["low", "medium", "high", "premium"]),
  contextWindow: z.number().int().positive(),
  surfaces: z.array(z.enum(["text", "voice"])),
  supportsTemperature: z.boolean(),
  recommended: z.boolean().optional(),
});
export type AdminModelProvider = z.infer<typeof ProviderSchema>;
export type AdminModel = z.infer<typeof ModelSchema>;

export const adminApi = {
  me: (): Promise<AdminMe> => apiFetch("/auth/me", AdminMeSchema),
  logout: (): Promise<void> =>
    apiFetch("/auth/logout", AdminMeSchema.optional(), { method: "POST" }) as Promise<void>,
  globalSearch: (
    input: Partial<AdminSearchQuery> = {},
  ): Promise<AdminSearchResponse> => {
    const query = AdminSearchQuerySchema.parse(input);
    const params = new URLSearchParams({
      q: query.q,
      limit: String(query.limit),
    });
    return apiFetch(`/search?${params.toString()}`, AdminSearchResponseSchema);
  },
  listDealerships: (search: string): Promise<Dealership[]> => {
    const qs = search.trim() ? `?search=${encodeURIComponent(search.trim())}` : "";
    return apiFetch(`/dealerships${qs}`, DealershipListSchema);
  },
  listDealershipDirectory: (
    input: Partial<DealershipDirectoryQuery> = {},
  ): Promise<DealershipDirectoryPage> => {
    const query = DealershipDirectoryQuerySchema.parse(input);
    const params = new URLSearchParams({
      archived: query.archived,
      page: String(query.page),
      pageSize: String(query.pageSize),
      sort: query.sort,
      direction: query.direction,
    });
    if (query.search) params.set("search", query.search);
    if (query.status) params.set("status", query.status);
    if (query.dealershipId) params.set("dealershipId", query.dealershipId);
    return apiFetch(`/dealerships/directory?${params.toString()}`, DealershipDirectoryPageSchema);
  },
  getDealership: (id: string): Promise<DealershipDetail> =>
    apiFetch(`/dealerships/${id}`, DealershipDetailSchema),
  onboard: (input: OnboardingCreateDto): Promise<DealershipDetail> => {
    const body = OnboardingCreateSchema.parse(input);
    return apiFetch("/dealerships/onboarding", DealershipDetailSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  connectEmailChannel: (
    dealershipId: string,
    input: ConnectEmailChannelDto,
  ): Promise<Channel> => {
    const body = ConnectEmailChannelSchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/channels/email`, ChannelSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  checkEmailAvailability: (
    dealershipId: string,
    localPart: string,
    subdomain: string,
  ): Promise<EmailAddressAvailability> =>
    apiFetch(
      `/dealerships/${dealershipId}/email-address-available?localPart=${encodeURIComponent(localPart)}&subdomain=${encodeURIComponent(subdomain)}`,
      EmailAddressAvailabilitySchema,
    ),
  updateDealership: (id: string, input: UpdateDealershipDto): Promise<Dealership> => {
    const body = UpdateDealershipSchema.parse(input);
    return apiFetch(`/dealerships/${id}`, DealershipSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  archiveDealership: (id: string): Promise<Dealership> =>
    apiFetch(`/dealerships/${id}/archive`, DealershipSchema, { method: "POST" }),
  getDealershipOnboarding: (id: string): Promise<DealershipOnboarding> =>
    apiFetch(`/dealerships/${id}/onboarding`, DealershipOnboardingSchema),
  updateDealershipOnboardingStep: (
    id: string,
    input: UpdateOnboardingStepDto,
  ): Promise<DealershipOnboarding> =>
    apiFetch(`/dealerships/${id}/onboarding/steps`, DealershipOnboardingSchema, {
      method: "PATCH",
      body: JSON.stringify(input),
    }),
  unarchiveDealership: (id: string): Promise<Dealership> =>
    apiFetch(`/dealerships/${id}/unarchive`, DealershipSchema, { method: "POST" }),
  listRooftops: (dealershipId: string): Promise<Rooftop[]> =>
    apiFetch(`/dealerships/${dealershipId}/rooftops`, RooftopListSchema),
  getRooftop: (dealershipId: string, rooftopId: string): Promise<Rooftop> =>
    apiFetch(`/dealerships/${dealershipId}/rooftops/${rooftopId}`, RooftopSchema),
  createRooftop: (
    dealershipId: string,
    input: Omit<CreateRooftopDto, "dealershipId">,
  ): Promise<Rooftop> => {
    const body = CreateRooftopSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch(`/dealerships/${dealershipId}/rooftops`, RooftopSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateRooftop: (
    dealershipId: string,
    rooftopId: string,
    input: UpdateRooftopDto,
  ): Promise<Rooftop> => {
    const body = UpdateRooftopSchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/rooftops/${rooftopId}`, RooftopSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  removeRooftop: (dealershipId: string, rooftopId: string): Promise<void> =>
    apiFetch(`/dealerships/${dealershipId}/rooftops/${rooftopId}`, RooftopSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,
  listUsers: (dealershipId: string): Promise<User[]> =>
    apiFetch(`/dealerships/${dealershipId}/users`, UserListSchema),
  getUser: (dealershipId: string, userId: string): Promise<User> =>
    apiFetch(`/dealerships/${dealershipId}/users/${userId}`, UserSchema),
  createUser: (dealershipId: string, input: Omit<AdminCreateUserDto, "dealershipId">): Promise<User> => {
    const body = AdminCreateUserSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch(`/dealerships/${dealershipId}/users`, UserSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateUser: (
    dealershipId: string,
    userId: string,
    input: AdminUpdateUserDto,
  ): Promise<User> => {
    const body = AdminUpdateUserSchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/users/${userId}`, UserSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  removeUser: (dealershipId: string, userId: string): Promise<void> =>
    apiFetch(`/dealerships/${dealershipId}/users/${userId}`, UserSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,
  createUserMembership: (
    dealershipId: string,
    userId: string,
    input: Omit<CreateUserMembershipDto, "dealershipId" | "userId">,
  ): Promise<UserMembership> => {
    const body = CreateUserMembershipSchema.omit({
      dealershipId: true,
      userId: true,
    }).parse(input);
    return apiFetch(
      `/dealerships/${dealershipId}/users/${userId}/memberships`,
      UserMembershipSchema,
      { method: "POST", body: JSON.stringify(body) },
    );
  },
  updateUserMembership: (
    dealershipId: string,
    membershipId: string,
    input: UpdateUserMembershipDto,
  ): Promise<UserMembership> => {
    const body = UpdateUserMembershipSchema.parse(input);
    return apiFetch(
      `/dealerships/${dealershipId}/memberships/${membershipId}`,
      UserMembershipSchema,
      { method: "PATCH", body: JSON.stringify(body) },
    );
  },
  removeUserMembership: (dealershipId: string, membershipId: string): Promise<void> =>
    apiFetch(
      `/dealerships/${dealershipId}/memberships/${membershipId}`,
      UserMembershipSchema.optional(),
      { method: "DELETE" },
    ) as Promise<void>,
  listAdminActivities: (
    dealershipId?: string,
    limit?: number,
  ): Promise<AdminActivity[]> => {
    const params = new URLSearchParams();
    if (dealershipId) params.set("dealershipId", dealershipId);
    if (limit) params.set("limit", String(limit));
    const qs = params.toString() ? `?${params.toString()}` : "";
    return apiFetch(`/admin-activities${qs}`, AdminActivityListSchema);
  },
  listAdminActivityPage: (
    input: Partial<AdminActivityPageQuery> = {},
  ): Promise<AdminActivityPage> => {
    const query = AdminActivityPageQuerySchema.parse(input);
    const params = new URLSearchParams({
      page: String(query.page),
      pageSize: String(query.pageSize),
    });
    if (query.dealershipId) params.set("dealershipId", query.dealershipId);
    if (query.adminId) params.set("adminId", query.adminId);
    if (query.entityType) params.set("entityType", query.entityType);
    if (query.entityAction) params.set("entityAction", query.entityAction);
    if (query.dateFrom) params.set("dateFrom", query.dateFrom);
    if (query.dateTo) params.set("dateTo", query.dateTo);
    return apiFetch(`/admin-activities/page?${params.toString()}`, AdminActivityPageSchema);
  },
  listBdcActivities: (
    dealershipId: string,
    query: { contactId?: string; leadId?: string; page?: number; pageSize?: number } = {},
  ): Promise<ActivityPage> => {
    const params = new URLSearchParams();
    if (query.contactId) params.set("contactId", query.contactId);
    if (query.leadId) params.set("leadId", query.leadId);
    if (query.page) params.set("page", String(query.page));
    if (query.pageSize) params.set("pageSize", String(query.pageSize));
    const qs = params.toString() ? `?${params.toString()}` : "";
    return apiFetch(`/dealerships/${dealershipId}/activities${qs}`, ActivityPageSchema);
  },
  listContacts: (
    dealershipId: string,
    queryOrSearch: Partial<AdminContactDirectoryQuery> | string = {},
    legacyPage?: number,
    legacyPageSize?: number,
  ): Promise<ContactPage> => {
    const query =
      typeof queryOrSearch === "string"
        ? {
            search: queryOrSearch,
            page: legacyPage,
            pageSize: legacyPageSize,
          }
        : queryOrSearch;
    const params = new URLSearchParams();
    if (query.search?.trim()) params.set("search", query.search.trim());
    if (query.page) params.set("page", String(query.page));
    if (query.pageSize) params.set("pageSize", String(query.pageSize));
    if (query.status) params.set("status", query.status);
    if (query.assignedUserId) params.set("assignedUserId", query.assignedUserId);
    if (query.unassigned) params.set("unassigned", query.unassigned);
    if (query.source) params.set("source", query.source);
    if (query.preferredChannel) {
      params.set("preferredChannel", query.preferredChannel);
    }
    if (query.businessAccount) {
      params.set("businessAccount", query.businessAccount);
    }
    if (query.sort) params.set("sort", query.sort);
    const qs = params.toString() ? `?${params.toString()}` : "";
    return apiFetch(`/dealerships/${dealershipId}/contacts${qs}`, ContactPageSchema);
  },
  getContact: (dealershipId: string, contactId: string): Promise<Contact> =>
    apiFetch(`/dealerships/${dealershipId}/contacts/${contactId}`, ContactSchema),
  createContact: (
    dealershipId: string,
    input: Omit<CreateContactDto, "dealershipId">,
  ): Promise<Contact> => {
    const body = CreateContactSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch(`/dealerships/${dealershipId}/contacts`, ContactSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateContact: (
    dealershipId: string,
    contactId: string,
    input: UpdateContactDto,
  ): Promise<Contact> => {
    const body = UpdateContactSchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/contacts/${contactId}`, ContactSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  // -------- Customer 360 reads (admin audit, read-only) --------------
  listVehicleInterests: (
    dealershipId: string,
    contactId?: string,
    opts: { page?: number; pageSize?: number } = {},
  ): Promise<VehicleInterestPage> => {
    const qs = contactListQuery(contactId, opts);
    return apiFetch(
      `/dealerships/${dealershipId}/vehicle-interests${qs}`,
      VehicleInterestPageSchema,
    );
  },
  listContactVehicles: (
    dealershipId: string,
    contactId?: string,
    opts: { page?: number; pageSize?: number } = {},
  ): Promise<ContactVehiclePage> => {
    const qs = contactListQuery(contactId, opts);
    return apiFetch(
      `/dealerships/${dealershipId}/contact-vehicles${qs}`,
      ContactVehiclePageSchema,
    );
  },
  listTradeIns: (
    dealershipId: string,
    contactId?: string,
    opts: { page?: number; pageSize?: number } = {},
  ): Promise<TradeInPage> => {
    const qs = contactListQuery(contactId, opts);
    return apiFetch(`/dealerships/${dealershipId}/trade-ins${qs}`, TradeInPageSchema);
  },
  listFollowUps: (
    dealershipId: string,
    contactId?: string,
    opts: { page?: number; pageSize?: number } = {},
  ): Promise<FollowUpPage> => {
    const qs = contactListQuery(contactId, opts);
    return apiFetch(`/dealerships/${dealershipId}/follow-ups${qs}`, FollowUpPageSchema);
  },
  listConsentEvents: (
    dealershipId: string,
    contactId?: string,
    opts: { page?: number; pageSize?: number } = {},
  ): Promise<ConsentEventPage> => {
    const qs = contactListQuery(contactId, opts);
    return apiFetch(
      `/dealerships/${dealershipId}/consent-events${qs}`,
      ConsentEventPageSchema,
    );
  },
  listContactTags: (dealershipId: string, contactId: string): Promise<ContactTag[]> =>
    apiFetch(
      `/dealerships/${dealershipId}/contacts/${contactId}/tags`,
      ContactTagListSchema,
    ),
  listContactChannels: (dealershipId: string, contactId?: string): Promise<ContactChannelPage> => {
    const qs = contactId ? `?contactId=${encodeURIComponent(contactId)}` : "";
    return apiFetch(`/dealerships/${dealershipId}/contact-channels${qs}`, ContactChannelPageSchema);
  },
  createContactChannel: (
    dealershipId: string,
    input: Omit<CreateContactChannelDto, "dealershipId">,
  ): Promise<ContactChannel> => {
    const body = CreateContactChannelBodySchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/contact-channels`, ContactChannelSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateContactChannel: (
    dealershipId: string,
    contactChannelId: string,
    input: UpdateContactChannelDto,
  ): Promise<ContactChannel> => {
    const body = UpdateContactChannelSchema.parse(input);
    return apiFetch(
      `/dealerships/${dealershipId}/contact-channels/${contactChannelId}`,
      ContactChannelSchema,
      { method: "PATCH", body: JSON.stringify(body) },
    );
  },
  removeContactChannel: (dealershipId: string, contactChannelId: string): Promise<void> =>
    apiFetch(
      `/dealerships/${dealershipId}/contact-channels/${contactChannelId}`,
      ContactChannelSchema.optional(),
      { method: "DELETE" },
    ) as Promise<void>,
  listLeads: (
    dealershipId: string,
    query: {
      closed?: "true" | "false";
      contactId?: string;
      assignedUserId?: string | "unassigned";
      /** "Assigned to anyone" filter (server-side `assigned_user_id IS NOT NULL`). */
      assigned?: boolean;
      search?: string;
      includeAnonymous?: boolean;
      page?: number;
      pageSize?: number;
    } = {},
  ): Promise<LeadPage> => {
    const params = new URLSearchParams();
    if (query.closed) params.set("closed", query.closed);
    if (query.contactId) params.set("contactId", query.contactId);
    if (query.assignedUserId) params.set("assignedUserId", query.assignedUserId);
    if (query.assigned) params.set("assigned", "true");
    if (query.search?.trim()) params.set("search", query.search.trim());
    if (query.includeAnonymous) params.set("includeAnonymous", "true");
    if (query.page) params.set("page", String(query.page));
    if (query.pageSize) params.set("pageSize", String(query.pageSize));
    const qs = params.toString() ? `?${params.toString()}` : "";
    return apiFetch(`/dealerships/${dealershipId}/leads${qs}`, LeadPageSchema);
  },
  getLead: (dealershipId: string, leadId: string): Promise<Lead> =>
    apiFetch(
      `/dealerships/${dealershipId}/leads/${leadId}`,
      LeadSchema,
    ),
  updateLead: (
    dealershipId: string,
    leadId: string,
    input: UpdateLeadDto,
  ): Promise<Lead> => {
    const body = UpdateLeadSchema.parse(input);
    return apiFetch(
      `/dealerships/${dealershipId}/leads/${leadId}`,
      LeadSchema,
      { method: "PATCH", body: JSON.stringify(body) },
    );
  },
  createLead: (
    dealershipId: string,
    input: Omit<CreateLeadDto, "dealershipId">,
  ): Promise<Lead> => {
    const body = CreateLeadSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch(`/dealerships/${dealershipId}/leads`, LeadSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  listAppointments: (
    dealershipId: string,
    opts: {
      contactId?: string;
      from?: string;
      to?: string;
      page?: number;
      pageSize?: number;
    } = {},
  ): Promise<AppointmentPage> => {
    // Default pageSize 100 = the accepted calendar/window bound; the
    // per-contact tab overrides it with page/pageSize for "Show more".
    const params = new URLSearchParams({
      pageSize: String(opts.pageSize ?? 100),
    });
    if (opts.contactId) params.set("contactId", opts.contactId);
    if (opts.from) params.set("from", opts.from);
    if (opts.to) params.set("to", opts.to);
    if (opts.page) params.set("page", String(opts.page));
    return apiFetch(
      `/dealerships/${dealershipId}/appointments?${params.toString()}`,
      AppointmentPageSchema,
    );
  },
  createAppointment: (
    dealershipId: string,
    input: Omit<CreateAppointmentDto, "dealershipId">,
  ): Promise<Appointment> => {
    const body = CreateAppointmentSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch(`/dealerships/${dealershipId}/appointments`, AppointmentSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateAppointment: (
    dealershipId: string,
    appointmentId: string,
    input: UpdateAppointmentDto,
  ): Promise<Appointment> => {
    const body = UpdateAppointmentSchema.parse(input);
    return apiFetch(
      `/dealerships/${dealershipId}/appointments/${appointmentId}`,
      AppointmentSchema,
      {
        method: "PATCH",
        body: JSON.stringify(body),
      },
    );
  },
  listTasks: (
    dealershipId: string,
    query: {
      contactId?: string;
      status?: string;
      assignedUserId?: string;
      rooftopId?: string;
      /** Calendar window — effective-date BETWEEN [from, to). */
      from?: string;
      to?: string;
      page?: number;
      pageSize?: number;
    } = {},
  ): Promise<TaskPage> => {
    const params = new URLSearchParams();
    if (query.contactId) params.set("contactId", query.contactId);
    if (query.status) params.set("status", query.status);
    if (query.assignedUserId) params.set("assignedUserId", query.assignedUserId);
    if (query.rooftopId) params.set("rooftopId", query.rooftopId);
    if (query.from) params.set("from", query.from);
    if (query.to) params.set("to", query.to);
    if (query.page) params.set("page", String(query.page));
    if (query.pageSize) params.set("pageSize", String(query.pageSize));
    const qs = params.toString() ? `?${params.toString()}` : "";
    return apiFetch(`/dealerships/${dealershipId}/tasks${qs}`, TaskPageSchema);
  },
  createTask: (
    dealershipId: string,
    input: Omit<CreateTaskDto, "dealershipId">,
  ): Promise<Task> => {
    const body = CreateTaskSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch(`/dealerships/${dealershipId}/tasks`, TaskSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateTask: (
    dealershipId: string,
    taskId: string,
    input: UpdateTaskDto,
  ): Promise<Task> => {
    const body = UpdateTaskSchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/tasks/${taskId}`, TaskSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  completeTask: (dealershipId: string, taskId: string): Promise<Task> =>
    apiFetch(`/dealerships/${dealershipId}/tasks/${taskId}/complete`, TaskSchema, {
      method: "POST",
    }),
  cancelTask: (dealershipId: string, taskId: string): Promise<Task> =>
    apiFetch(`/dealerships/${dealershipId}/tasks/${taskId}/cancel`, TaskSchema, {
      method: "POST",
    }),
  startTask: (dealershipId: string, taskId: string): Promise<Task> =>
    apiFetch(`/dealerships/${dealershipId}/tasks/${taskId}/start`, TaskSchema, {
      method: "POST",
    }),
  snoozeTask: (
    dealershipId: string,
    taskId: string,
    input: SnoozeTaskDto,
  ): Promise<Task> => {
    const body = SnoozeTaskSchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/tasks/${taskId}/snooze`, TaskSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  assignTask: (
    dealershipId: string,
    taskId: string,
    input: AssignTaskDto,
  ): Promise<Task> => {
    const body = AssignTaskSchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/tasks/${taskId}/assign`, TaskSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  moveTask: (
    dealershipId: string,
    taskId: string,
    input: MoveTaskDto,
  ): Promise<Task> => {
    const body = MoveTaskSchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/tasks/${taskId}/move`, TaskSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  listChannels: (dealershipId: string): Promise<ChannelPage> =>
    apiFetch(`/dealerships/${dealershipId}/channels`, ChannelPageSchema),
  connections: (dealershipId: string): Promise<AdminConnectionsResponse> =>
    apiFetch(
      `/dealerships/${dealershipId}/connections`,
      AdminConnectionsResponseSchema,
    ),
  createChannel: (
    dealershipId: string,
    input: Omit<CreateChannelDto, "dealershipId">,
  ): Promise<Channel> => {
    const body = CreateChannelSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch(`/dealerships/${dealershipId}/channels`, ChannelSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateChannel: (
    dealershipId: string,
    channelId: string,
    input: UpdateChannelDto,
  ): Promise<Channel> => {
    const body = UpdateChannelSchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/channels/${channelId}`, ChannelSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  removeChannel: (dealershipId: string, channelId: string): Promise<void> =>
    apiFetch(`/dealerships/${dealershipId}/channels/${channelId}`, ChannelSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,

  // -------- X1: integration export audit trail ------------------------
  listIntegrationDeliveries: (
    dealershipId: string,
    integrationId: string,
  ): Promise<IntegrationDelivery[]> =>
    apiFetch(
      `/dealerships/${dealershipId}/integrations/${integrationId}/deliveries`,
      z.array(IntegrationDeliverySchema),
    ),

  // -------- X3: public-API keys ---------------------------------------
  listApiKeys: (dealershipId: string): Promise<ApiKey[]> =>
    apiFetch(`/dealerships/${dealershipId}/api-keys`, z.array(ApiKeySchema)),
  createApiKey: (
    dealershipId: string,
    input: { name: string; scopes: string[] },
  ): Promise<ApiKeyCreated> =>
    apiFetch(`/dealerships/${dealershipId}/api-keys`, ApiKeyCreatedSchema, {
      method: "POST",
      body: JSON.stringify(input),
    }),
  revokeApiKey: (dealershipId: string, id: string): Promise<ApiKey> =>
    apiFetch(`/dealerships/${dealershipId}/api-keys/${id}`, ApiKeySchema, {
      method: "DELETE",
    }),

  // -------- Integrations (Space Auto / ADF) --------------------------
  listIntegrations: (dealershipId: string): Promise<Integration[]> =>
    apiFetch(
      `/dealerships/${dealershipId}/integrations`,
      IntegrationListSchema,
    ),
  createIntegration: (
    dealershipId: string,
    input: CreateIntegration,
  ): Promise<Integration> => {
    const body = CreateIntegrationSchema.parse(input);
    return apiFetch(
      `/dealerships/${dealershipId}/integrations`,
      IntegrationSchema,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },
  updateIntegration: (
    dealershipId: string,
    integrationId: string,
    input: UpdateIntegration,
  ): Promise<Integration> => {
    const body = UpdateIntegrationSchema.parse(input);
    return apiFetch(
      `/dealerships/${dealershipId}/integrations/${integrationId}`,
      IntegrationSchema,
      {
        method: "PATCH",
        body: JSON.stringify(body),
      },
    );
  },
  resyncIntegration: (
    dealershipId: string,
    integrationId: string,
  ): Promise<Integration> =>
    apiFetch(
      `/dealerships/${dealershipId}/integrations/${integrationId}/resync`,
      IntegrationSchema,
      { method: "POST" },
    ),
  removeIntegration: (
    dealershipId: string,
    integrationId: string,
  ): Promise<void> =>
    apiFetch(
      `/dealerships/${dealershipId}/integrations/${integrationId}`,
      IntegrationSchema.optional(),
      { method: "DELETE" },
    ) as Promise<void>,
  verifyIntegrationToken: (
    dealershipId: string,
    input: VerifyIntegrationTokenRequest,
  ): Promise<VerifyIntegrationTokenResponse> => {
    const body = VerifyIntegrationTokenRequestSchema.parse(input);
    return apiFetch(
      `/dealerships/${dealershipId}/integrations/verify-token`,
      VerifyIntegrationTokenResponseSchema,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },
  getChannelOnboarding: (
    dealershipId: string,
    channelId: string,
  ): Promise<ChannelOnboardingInfo> =>
    apiFetch(
      `/dealerships/${dealershipId}/channels/${channelId}/onboarding`,
      ChannelOnboardingInfoSchema,
    ),
  listInventory: (dealershipId: string, search = ""): Promise<InventoryVehiclePage> =>
    apiFetch(
      `/dealerships/${dealershipId}/inventory-vehicles${searchQuery(search)}`,
      InventoryVehiclePageSchema,
    ),
  /**
   * Faceted search — feeds the faceted-grid Inventory page. Backed by
   * the same `runInventorySearch` helper in `backend-common` that the
   * dealer surface uses, so admin and dealer see identical facet shapes.
   */
  searchInventory: (
    dealershipId: string,
    body: InventorySearchRequest,
  ): Promise<InventorySearchResponse> => {
    const validated = InventorySearchRequestSchema.parse(body);
    return apiFetch(
      `/dealerships/${dealershipId}/inventory-vehicles/search`,
      InventorySearchResponseSchema,
      { method: "POST", body: JSON.stringify(validated) },
    );
  },
  getInventoryByVin: (
    dealershipId: string,
    vin: string,
  ): Promise<InventoryVehicle> =>
    apiFetch(
      `/dealerships/${dealershipId}/inventory-vehicles/by-vin/${encodeURIComponent(vin)}`,
      InventoryVehicleSchema,
    ),
  createInventory: (
    dealershipId: string,
    input: Omit<CreateInventoryVehicleDto, "dealershipId">,
  ): Promise<InventoryVehicle> => {
    const body = CreateInventoryVehicleSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch(`/dealerships/${dealershipId}/inventory-vehicles`, InventoryVehicleSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateInventory: (
    dealershipId: string,
    vehicleId: string,
    input: UpdateInventoryVehicleDto,
  ): Promise<InventoryVehicle> => {
    const body = UpdateInventoryVehicleSchema.parse(input);
    return apiFetch(
      `/dealerships/${dealershipId}/inventory-vehicles/${vehicleId}`,
      InventoryVehicleSchema,
      {
        method: "PATCH",
        body: JSON.stringify(body),
      },
    );
  },
  removeInventory: (dealershipId: string, vehicleId: string): Promise<void> =>
    apiFetch(
      `/dealerships/${dealershipId}/inventory-vehicles/${vehicleId}`,
      InventoryVehicleSchema.optional(),
      { method: "DELETE" },
    ) as Promise<void>,

  aiAgents: (dealershipId: string): Promise<AiAgent[]> =>
    apiFetch(`/dealerships/${dealershipId}/ai-agents`, AiAgentListSchema),
  createAiAgent: (
    dealershipId: string,
    input: Omit<CreateAiAgentDto, "dealershipId">,
  ): Promise<AiAgent> => {
    const body = CreateAiAgentBodySchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/ai-agents`, AiAgentSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateAiAgent: (
    dealershipId: string,
    agentId: string,
    input: UpdateAiAgentDto,
  ): Promise<AiAgent> => {
    const body = UpdateAiAgentSchema.parse(input);
    return apiFetch(`/dealerships/${dealershipId}/ai-agents/${agentId}`, AiAgentSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },

  // Model catalog (B1) — drives Provider/Model selects in the agent form.
  modelProviders: (): Promise<AdminModelProvider[]> =>
    apiFetch("/models/providers", z.array(ProviderSchema)),
  listModels: (provider: string): Promise<AdminModel[]> =>
    apiFetch(
      `/models?provider=${encodeURIComponent(provider)}`,
      z.array(ModelSchema),
    ),

  aiSkills: (dealershipId: string): Promise<AiSkill[]> =>
    apiFetch(`/dealerships/${dealershipId}/ai-skills`, AiSkillListSchema),
  createAiSkill: (
    dealershipId: string,
    input: Omit<CreateAiSkillDto, "dealershipId">,
  ): Promise<AiSkill> => {
    const body = CreateAiSkillSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch(`/dealerships/${dealershipId}/ai-skills`, AiSkillSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  aiAgentChannelAssignments: (
    dealershipId: string,
  ): Promise<AiAgentChannelAssignment[]> =>
    apiFetch(
      `/dealerships/${dealershipId}/ai-agent-channel-assignments`,
      AiAgentChannelAssignmentListSchema,
    ),
  createAiAgentChannelAssignment: (
    dealershipId: string,
    input: Omit<CreateAiAgentChannelAssignmentDto, "dealershipId">,
  ): Promise<AiAgentChannelAssignment> => {
    const body = CreateAiAgentChannelAssignmentSchema.omit({ dealershipId: true }).parse(input);
    return apiFetch(
      `/dealerships/${dealershipId}/ai-agent-channel-assignments`,
      AiAgentChannelAssignmentSchema,
      { method: "POST", body: JSON.stringify(body) },
    );
  },

  // Telephony Accounts (TELEPHONY.md §"Telephony Accounts"). One row
  // per legal entity (EIN), wrapping a Twilio subaccount. The UI calls
  // it "Telephony Account" — never "Twilio".
  telephonyAccounts: (dealershipId: string): Promise<TelephonyAccount[]> =>
    apiFetch(
      `/dealerships/${dealershipId}/telephony-accounts`,
      TelephonyAccountListSchema,
    ),
  telephonyAccount: (id: string): Promise<TelephonyAccount> =>
    apiFetch(`/telephony-accounts/${id}`, TelephonyAccountSchema),
  createTelephonyAccount: (
    dealershipId: string,
    input: CreateTelephonyAccountDto,
  ): Promise<TelephonyAccount> => {
    const body = CreateTelephonyAccountSchema.parse(input);
    return apiFetch(
      `/dealerships/${dealershipId}/telephony-accounts`,
      TelephonyAccountSchema,
      { method: "POST", body: JSON.stringify(body) },
    );
  },
  updateTelephonyAccount: (
    id: string,
    input: UpdateTelephonyAccountDto,
  ): Promise<TelephonyAccount> => {
    const body = UpdateTelephonyAccountSchema.parse(input);
    return apiFetch(`/telephony-accounts/${id}`, TelephonyAccountSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  removeTelephonyAccount: (id: string): Promise<void> =>
    apiFetch(`/telephony-accounts/${id}`, TelephonyAccountSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,
  // "Connect Existing" (many-to-many account↔dealership): search
  // accounts not yet connected to this dealership, then link/unlink.
  searchTelephonyAccounts: (
    q: string,
    excludeDealershipId: string,
  ): Promise<TelephonyAccountSearchResult[]> =>
    apiFetch(
      `/telephony-accounts/search?q=${encodeURIComponent(q)}&excludeDealershipId=${encodeURIComponent(excludeDealershipId)}`,
      TelephonyAccountSearchResultListSchema,
    ),
  connectTelephonyAccount: (dealershipId: string, accountId: string): Promise<void> =>
    apiFetch(
      `/dealerships/${dealershipId}/telephony-accounts/${accountId}/connect`,
      z.void().optional(),
      { method: "POST" },
    ) as Promise<void>,
  disconnectTelephonyAccount: (
    dealershipId: string,
    accountId: string,
  ): Promise<void> =>
    apiFetch(
      `/dealerships/${dealershipId}/telephony-accounts/${accountId}/connect`,
      z.void().optional(),
      { method: "DELETE" },
    ) as Promise<void>,

  // Phone numbers (TELEPHONY.md Flow 4). Search/purchase live under
  // the Telephony Account; routing + release live on the number row.
  telephonySearchNumbers: (
    telephonyAccountId: string,
    input: TelephonySearchNumbersDto,
  ): Promise<TelephonyAvailableNumber[]> => {
    const body = TelephonySearchNumbersSchema.parse(input);
    return apiFetch(
      `/telephony-accounts/${telephonyAccountId}/phone-numbers/search`,
      TelephonyAvailableNumberListSchema,
      { method: "POST", body: JSON.stringify(body) },
    );
  },
  telephonyPurchaseNumber: (
    dealershipId: string,
    telephonyAccountId: string,
    input: TelephonyPurchaseNumberDto,
  ): Promise<TelephonyPhoneNumber> => {
    const body = TelephonyPurchaseNumberSchema.parse(input);
    // Dealership-scoped: the number lands on this dealership's
    // association with the account (shared accounts buy for one
    // dealership at a time).
    return apiFetch(
      `/dealerships/${dealershipId}/telephony-accounts/${telephonyAccountId}/phone-numbers`,
      TelephonyPhoneNumberSchema,
      { method: "POST", body: JSON.stringify(body) },
    );
  },
  telephonyAccountNumbers: (
    telephonyAccountId: string,
  ): Promise<TelephonyPhoneNumber[]> =>
    apiFetch(
      `/telephony-accounts/${telephonyAccountId}/phone-numbers`,
      TelephonyPhoneNumberListSchema,
    ),
  telephonyDealershipNumbers: (
    dealershipId: string,
  ): Promise<TelephonyPhoneNumber[]> =>
    apiFetch(
      `/dealerships/${dealershipId}/phone-numbers`,
      TelephonyPhoneNumberListSchema,
    ),
  telephonyUpdateNumber: (
    id: string,
    input: TelephonyUpdateNumberDto,
  ): Promise<TelephonyPhoneNumber> => {
    const body = TelephonyUpdateNumberSchema.parse(input);
    return apiFetch(`/telephony-phone-numbers/${id}`, TelephonyPhoneNumberSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  telephonyReleaseNumber: (id: string): Promise<void> =>
    apiFetch(`/telephony-phone-numbers/${id}`, TelephonyPhoneNumberSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,
  telephonySmsEnable: (id: string): Promise<TelephonyPhoneNumber> =>
    apiFetch(`/telephony-phone-numbers/${id}/sms-enable`, TelephonyPhoneNumberSchema, {
      method: "POST",
    }),
  telephonySmsDisable: (id: string): Promise<TelephonyPhoneNumber> =>
    apiFetch(`/telephony-phone-numbers/${id}/sms-disable`, TelephonyPhoneNumberSchema, {
      method: "POST",
    }),

  // A2P wizard (TELEPHONY.md Flow 5).
  a2pSaveBusinessProfile: (
    telephonyAccountId: string,
    input: A2pBusinessProfileDto,
  ): Promise<TelephonyAccount> => {
    const body = A2pBusinessProfileSchema.parse(input);
    return apiFetch(
      `/telephony-accounts/${telephonyAccountId}/business-profile`,
      TelephonyAccountSchema,
      { method: "POST", body: JSON.stringify(body) },
    );
  },
  a2pSubmitBrand: (
    telephonyAccountId: string,
    input: A2pSubmitBrandDto,
  ): Promise<TelephonyAccount> => {
    const body = A2pSubmitBrandSchema.parse(input);
    return apiFetch(
      `/telephony-accounts/${telephonyAccountId}/brand`,
      TelephonyAccountSchema,
      { method: "POST", body: JSON.stringify(body) },
    );
  },
  a2pResendOtp: (telephonyAccountId: string): Promise<TelephonyAccount> =>
    apiFetch(
      `/telephony-accounts/${telephonyAccountId}/brand/otp/resend`,
      TelephonyAccountSchema,
      { method: "POST" },
    ),
  a2pRefreshBrand: (telephonyAccountId: string): Promise<TelephonyAccount> =>
    apiFetch(
      `/telephony-accounts/${telephonyAccountId}/brand/refresh`,
      TelephonyAccountSchema,
      { method: "POST" },
    ),
  a2pSubmitCampaign: (
    telephonyAccountId: string,
    input: A2pSubmitCampaignDto,
  ): Promise<{ id: string; sid: string | null; status: string }> => {
    const body = A2pSubmitCampaignSchema.parse(input);
    return apiFetch(
      `/telephony-accounts/${telephonyAccountId}/campaigns`,
      // The endpoint returns a thin status snapshot; we don't need the
      // full campaign row in the admin UI yet.
      z.object({
        id: z.string().uuid(),
        sid: z.string().nullable(),
        status: z.string(),
      }),
      { method: "POST", body: JSON.stringify(body) },
    );
  },
  a2pStatus: (telephonyAccountId: string): Promise<A2pStatus> =>
    apiFetch(
      `/telephony-accounts/${telephonyAccountId}/a2p-status`,
      A2pStatusSchema,
    ),

  // Usage (TELEPHONY.md §"Usage and Billing").
  telephonyAccountUsage: (
    telephonyAccountId: string,
    range: { start: string; end: string },
  ): Promise<TelephonyUsageSummary> => {
    const params = new URLSearchParams(range);
    return apiFetch(
      `/telephony-accounts/${telephonyAccountId}/usage?${params}`,
      TelephonyUsageSummarySchema,
    );
  },
  telephonyDealershipUsage: (
    dealershipId: string,
    range: { start: string; end: string },
  ): Promise<TelephonyUsageSummary> => {
    const params = new URLSearchParams(range);
    return apiFetch(
      `/dealerships/${dealershipId}/usage?${params}`,
      TelephonyUsageSummarySchema,
    );
  },
  telephonyAccountUsageSync: (
    telephonyAccountId: string,
    range: { start: string; end: string },
  ): Promise<{ rowsUpserted: number }> => {
    const params = new URLSearchParams(range);
    return apiFetch(
      `/telephony-accounts/${telephonyAccountId}/usage/sync?${params}`,
      z.object({ rowsUpserted: z.number() }),
      { method: "POST" },
    );
  },

  // M10 — ops/health snapshot.
  opsSnapshot: (): Promise<OpsSnapshot> => apiFetch(`/ops`, OpsSnapshotSchema),

  // Billing — admin AI Usage + Twilio billing combined.
  dealershipBilling: (
    dealershipId: string,
    range: { start: string; end: string },
  ): Promise<DealershipBillingSummary> => {
    const params = new URLSearchParams(range);
    return apiFetch(
      `/billing/dealerships/${dealershipId}?${params}`,
      DealershipBillingSummarySchema,
    );
  },
  platformBilling: (
    range: { start: string; end: string },
  ): Promise<PlatformBillingSummary> => {
    const params = new URLSearchParams(range);
    return apiFetch(`/billing/platform?${params}`, PlatformBillingSummarySchema);
  },

  // -------- Inventory Imports (per-dealership) -----------------------
  listInventoryImports: (dealershipId: string): Promise<InventoryImport[]> =>
    apiFetch(
      `/dealerships/${dealershipId}/inventory-imports`,
      InventoryImportListSchema,
    ),
  getInventoryImport: (
    dealershipId: string,
    id: string,
  ): Promise<InventoryImport> =>
    apiFetch(
      `/dealerships/${dealershipId}/inventory-imports/${id}`,
      InventoryImportSchema,
    ),
  listInventoryImportRuns: (
    dealershipId: string,
    id: string,
  ): Promise<InventoryImportRun[]> =>
    apiFetch(
      `/dealerships/${dealershipId}/inventory-imports/${id}/runs`,
      InventoryImportRunListSchema,
    ),
  createInventoryImport: (
    dealershipId: string,
    body: CreateInventoryImport,
  ): Promise<InventoryImport> =>
    apiFetch(
      `/dealerships/${dealershipId}/inventory-imports`,
      InventoryImportSchema,
      { method: "POST", body: JSON.stringify(body) },
    ),
  updateInventoryImport: (
    dealershipId: string,
    id: string,
    body: UpdateInventoryImport,
  ): Promise<InventoryImport> =>
    apiFetch(
      `/dealerships/${dealershipId}/inventory-imports/${id}`,
      InventoryImportSchema,
      { method: "PATCH", body: JSON.stringify(body) },
    ),
  removeInventoryImport: (dealershipId: string, id: string): Promise<void> =>
    apiFetch(
      `/dealerships/${dealershipId}/inventory-imports/${id}`,
      z.undefined(),
      { method: "DELETE" },
    ) as Promise<void>,
  /** Force an immediate sync for one import (no wait for the next cron). */
  syncInventoryImport: (
    dealershipId: string,
    id: string,
  ): Promise<InventoryImport> =>
    apiFetch(
      `/dealerships/${dealershipId}/inventory-imports/${id}/sync`,
      InventoryImportSchema,
      { method: "POST" },
    ),
  /**
   * Arm a one-shot override of the sold-mark safety rails for one import
   * (spent by the next run a rail would have blocked).
   */
  approveInventoryImportBulkRetire: (
    dealershipId: string,
    id: string,
  ): Promise<InventoryImport> =>
    apiFetch(
      `/dealerships/${dealershipId}/inventory-imports/${id}/approve-bulk-retire`,
      InventoryImportSchema,
      { method: "POST" },
    ),

  // -------- Outreach (internal dealer-prospect CRM) ------------------
  // Lumika's own sales pipeline of prospective dealerships — top-level,
  // isolated from the per-dealership product surfaces above.
  listAdmins: (): Promise<Admin[]> => apiFetch("/admins", z.array(AdminSchema)),
  outreachSummary: (): Promise<OutreachSummary> =>
    apiFetch("/outreach/summary", OutreachSummarySchema),
  listOutreachProspects: (
    query: Partial<OutreachListQuery> = {},
  ): Promise<OutreachProspectPage> => {
    const params = new URLSearchParams();
    if (query.search?.trim()) params.set("search", query.search.trim());
    if (query.stage) params.set("stage", query.stage);
    if (query.owner) params.set("owner", query.owner);
    if (query.due) params.set("due", "true");
    if (query.page) params.set("page", String(query.page));
    if (query.limit) params.set("limit", String(query.limit));
    const qs = params.toString() ? `?${params.toString()}` : "";
    return apiFetch(`/outreach/prospects${qs}`, OutreachProspectPageSchema);
  },
  getOutreachProspect: (id: string): Promise<OutreachProspect> =>
    apiFetch(`/outreach/prospects/${id}`, OutreachProspectSchema),
  createOutreachProspect: (input: CreateOutreachProspectDto): Promise<OutreachProspect> => {
    const body = CreateOutreachProspectSchema.parse(input);
    return apiFetch("/outreach/prospects", OutreachProspectSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  updateOutreachProspect: (
    id: string,
    input: UpdateOutreachProspectDto,
  ): Promise<OutreachProspect> => {
    const body = UpdateOutreachProspectSchema.parse(input);
    return apiFetch(`/outreach/prospects/${id}`, OutreachProspectSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },
  removeOutreachProspect: (id: string): Promise<void> =>
    apiFetch(`/outreach/prospects/${id}`, OutreachProspectSchema.optional(), {
      method: "DELETE",
    }) as Promise<void>,
  listOutreachNotes: (id: string): Promise<OutreachNote[]> =>
    apiFetch(`/outreach/prospects/${id}/notes`, z.array(OutreachNoteSchema)),
  addOutreachNote: (id: string, input: CreateOutreachNoteDto): Promise<OutreachNote> => {
    const body = CreateOutreachNoteSchema.parse(input);
    return apiFetch(`/outreach/prospects/${id}/notes`, OutreachNoteSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  /** F8 — one manual email to a prospect; server records an 'email' note. */
  emailOutreachProspect: (
    id: string,
    input: EmailOutreachProspectDto,
  ): Promise<OutreachNote> => {
    const body = EmailOutreachProspectSchema.parse(input);
    return apiFetch(`/outreach/prospects/${id}/email`, OutreachNoteSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
  importOutreachProspects: (
    rows: CreateOutreachProspectDto[],
  ): Promise<ImportOutreachResult> => {
    const body = ImportOutreachProspectsSchema.parse({ rows });
    return apiFetch("/outreach/prospects/import", ImportOutreachResultSchema, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },
};

function searchQuery(search: string): string {
  return search.trim() ? `?search=${encodeURIComponent(search.trim())}` : "";
}

// Shared query-string builder for the per-contact Customer-360 lists, all of
// which take an optional contactId filter plus page/pageSize pagination.
function contactListQuery(
  contactId?: string,
  opts: { page?: number; pageSize?: number } = {},
): string {
  const params = new URLSearchParams();
  if (contactId) params.set("contactId", contactId);
  if (opts.page) params.set("page", String(opts.page));
  if (opts.pageSize) params.set("pageSize", String(opts.pageSize));
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}
